import NavBar from './components/navBar/NavBar';
import Main from './components/main/Main';
import MainBig from './components/mainBig/MainBig';

export default function App() {
  return (
    <>
      <NavBar />
      <Main />
      <MainBig />
    </>
  );
}
